var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLaunch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 12,
    fill: "none",
    viewBox: "0 0 10 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M2.03701 5.0552C1.6884 3.0372 3.6481 0.653649 4.99961 0C6.36245 0.73919 8.27954 2.95461 7.95486 5.0552C7.63018 7.15579 7.09988 10.1104 7.09988 10.1104H2.89348C2.89348 10.1104 2.38562 7.07321 2.03701 5.0552ZM0.599609 7.68554L1.59617 6.38299L2.19961 10.1566L0.599609 11.1854V7.68554ZM8.40305 6.38299L9.39961 7.68554V11.1854L7.79961 10.1566L8.40305 6.38299ZM4.96809 12C4.2578 11.4988 3.79268 10.3992 3.79268 10.3992H6.19268C6.19268 10.3992 5.92753 11.2479 4.96809 12Z",
    clipRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaunch);
export default __webpack_public_path__ + "static/media/launch.2b76769fb44c4566e5b4e7a81a7db745.svg";
export { ForwardRef as ReactComponent };